/**
 * Applies the given filter function to a Relay page of entities and returns a new page with only the filtered entities.
 * @typeParam E - Entity type passed into the filter function
 * @param page - Page of Relay results from a database query
 * @param filter - Filter function which accepts E and returns boolean (or Promise<boolean>)
 */
export async function filterRelayPage<Entity, PageInfo>(
  page: {
    edges: { cursor: string; node: Entity }[];
    pageInfo: PageInfo;
  },
  filter: (entity: Entity) => boolean | Promise<boolean>
): Promise<{
  pageInfo: PageInfo;
  edges: {
    cursor: string;
    node: Entity;
  }[];
}> {
  const filteredEdges = await Promise.all(
    page.edges.map(async (edge) => {
      const shouldInclude = await filter(edge.node);
      return shouldInclude ? edge : null;
    })
  );

  return {
    pageInfo: page.pageInfo,
    edges: filteredEdges.filter(
      (edge): edge is { cursor: string; node: Entity } => edge !== null
    ),
  };
}
